export default class AgeRating {
    constructor() {
        this.id          = null;
        this.age         = null;
        this.rating      = '';
        this.description = '';
    }
}
